webpackJsonp([14],{

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_KanbanAdjust_js__ = __webpack_require__(1294);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e11992_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KanbanAdjust_vue__ = __webpack_require__(1482);
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_KanbanAdjust_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e11992_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KanbanAdjust_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(40);
var core = __webpack_require__(19);
var fails = __webpack_require__(66);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1150), __esModule: true };

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1151);
module.exports = __webpack_require__(19).Object.keys;


/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(83);
var $keys = __webpack_require__(84);

__webpack_require__(1133)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 1160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  getCycleListFactorByDate: function getCycleListFactorByDate(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjust/getcyclelistfactorbydate', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getCycleListByBetweenDate: function getCycleListByBetweenDate(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjust/getcyclelistfactorbybetweendate', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPartlinkage: function getPartlinkage(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjust/getpartlinkage', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPartlinkageDetail: function getPartlinkageDetail(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjust/getpartlinkagedetail', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getKanbanAdjustList: function getKanbanAdjustList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjust/getkanbanadjustlist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addKanbanAdjustFactor: function addKanbanAdjustFactor(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjust/addfactor', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  rmKanbanAdjust: function rmKanbanAdjust(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(URL + 'kanbanadjust/removekanbanadjust', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  rmKanbanAdjustList: function rmKanbanAdjustList(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjust/cancelkanbanadjustlist', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getKanbanAdjustListById: function getKanbanAdjustListById(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjust/getkanbanadjustbyid', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkAdjust: function checkAdjust(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjust/checkadjust', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  createAdjust: function createAdjust(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjust/createadjust', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getDockBySpl: function getDockBySpl(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'getref/dockbyspl', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSupplierByDk: function getSupplierByDk(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'getref/supplierbydk', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPartByDkSpl: function getPartByDkSpl(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'getref/partbydkspl', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
  //   approveAdjust (URL, obj, header, success, error) {
  //     Vue.axios.post(URL + 'adjust/approve', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   addAdj (URL, obj, header, success, error) {
  //     Vue.axios.post(URL + 'adjust', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   editAdj (URL, obj, header, success, error) {
  //     Vue.axios.put(URL + 'adjust', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   rmAdjustDetail (URL, header, success, error) {
  //     Vue.axios.delete(URL + 'adjust/detail', header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   exportDatas (URL, header, success, error) {
  //     Vue.axios.get(URL + 'adjust/export', header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   }

});

/***/ }),

/***/ 1294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_KanbanAdjust__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_KanbanAdjustUpload__ = __webpack_require__(1480);
// import api2 from '../../models/reportkanban'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'KanbanAdjust',
  components: {
    KanbanAdjustUploadModal: __WEBPACK_IMPORTED_MODULE_1__components_modal_KanbanAdjustUpload__["a" /* default */]
  },
  data: function data() {
    return {
      // default
      is_load: false,
      per_page: 100,
      active_page: 1,
      // page
      search_date: null,
      search_text: '',
      result_data: {
        pagination: [],
        count: 0
      },
      is_auto: '99',
      dock: '',
      dock_list: [],
      supplier: '',
      supplier_list: [],
      part: '',
      part_list: [],
      str_data: ''
    };
  },
  created: function created() {
    this.checkOAuth();
    this.active_page = typeof this.$route.params.active_page !== 'undefined' ? this.$route.params.active_page : 1;
    this.dock = typeof this.$route.params.dock !== 'undefined' ? this.$route.params.dock : '';
    this.supplier = typeof this.$route.params.supplier !== 'undefined' ? this.$route.params.supplier : '';
    this.part = typeof this.$route.params.part !== 'undefined' ? this.$route.params.part : '';
    this.is_auto = typeof this.$route.params.is_auto !== 'undefined' ? this.$route.params.is_auto : '99';
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      if (sessionStorage.token) {
        _this.getDock();
        _this.getSupplierList();
        _this.GetPart();
        _this.search();
      } else {
        setTimeout(function () {
          _this.getDock();
          _this.getSupplierList();
          _this.GetPart();
          _this.search();
        }, 300);
      }
      // select dock
      $('#select2-dock').select2({
        placeholder: 'Select Dock',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-dock').on('select2:select', function (e) {
        _this.changeDock($('#select2-dock').val());
      });
      $('#select2-dock').on('select2:clear', function (e) {
        _this.changeDock('');
      });
      // select part
      $('#select2-supplier').select2({
        placeholder: 'Select Supplier',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-supplier').on('select2:select', function (e) {
        _this.changeSupplier($('#select2-supplier').val());
      });
      $('#select2-supplier').on('select2:clear', function (e) {
        _this.changeSupplier('');
      });
      // select part
      $('#select2-part').select2({
        placeholder: 'Select Part',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-part').on('select2:select', function (e) {
        _this.changePart($('#select2-part').val());
      });
      $('#select2-part').on('select2:clear', function (e) {
        _this.changePart('');
      });
    }, 1000);
  },

  methods: {
    itemRender: function itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous';
      } else if (type === 'next') {
        return 'Next';
      }
      return originalElement;
    },
    activePage: function activePage(value) {
      this.active_page = value;
      this.search();
    },
    adjustManage: function adjustManage(obj) {
      this.$router.push({
        name: 'KanbanAdjustManage',
        params: {
          ps_id: obj.ps_id,
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      });
    },
    changeDock: function changeDock(id) {
      this.dock = id;
      this.getSupplierList();
      this.GetPart();
    },
    changeSupplier: function changeSupplier(id) {
      this.supplier = id;
      this.getDock();
      this.GetPart();
    },
    changePart: function changePart(id) {
      this.part = id;
    },
    getDock: function getDock() {
      var _this2 = this;

      this.dock_list = [];
      this.header.params = { spl_id: this.supplier };
      __WEBPACK_IMPORTED_MODULE_0__models_KanbanAdjust__["a" /* default */].getDockBySpl(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this2.dock_list = result.data.dock_list;
        } else {
          // this.alert_msg('warning', 'An error occurred.', result.message)
        }
      }, function (error) {
        _this2.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    getSupplierList: function getSupplierList() {
      var _this3 = this;

      this.supplier_list = [];
      this.header.params = { dk_id: this.dock };
      __WEBPACK_IMPORTED_MODULE_0__models_KanbanAdjust__["a" /* default */].getSupplierByDk(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this3.supplier_list = result.data.supplier_list;
        } else {
          // this.alert_msg('warning', 'An error occurred.', result.message)
        }
      }, function (error) {
        _this3.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    GetPart: function GetPart() {
      var _this4 = this;

      this.part_list = [];
      this.header.params = { dk_id: this.dock, spl_id: this.supplier };
      __WEBPACK_IMPORTED_MODULE_0__models_KanbanAdjust__["a" /* default */].getPartByDkSpl(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this4.part_list = result.data.part_list;
        } else {
          // this.alert_msg('warning', 'An error occurred.', result.message)
        }
      }, function (error) {
        _this4.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    search: function search() {
      var _this5 = this;

      this.is_load = true;
      var obj = {
        search: this.search_text,
        spl_id: this.supplier,
        dk_id: this.dock,
        part_id: this.part,
        is_auto: this.is_auto,
        limit: this.per_page,
        page: this.active_page
      };
      this.result_data = {
        pagination: [],
        count: 0
      };
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_0__models_KanbanAdjust__["a" /* default */].getPartlinkage(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this5.result_data = result.data;
        } else {
          _this5.alert_msg('warning', 'Get Part Linkage', result.message);
        }
        _this5.is_load = false;
      }, function (error) {
        _this5.alert_msg('error', 'Report Part Linkage', error.message);
        _this5.is_load = false;
      });
    },

    // upload V.3
    goKanbanAdjustDayoffUpload: function goKanbanAdjustDayoffUpload() {
      this.$router.push({
        name: 'KanbanAdjustDayoffUpload',
        params: {
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      });
    },
    goKanbanAdjustFactorUpload: function goKanbanAdjustFactorUpload() {
      this.$router.push({
        name: 'KanbanAdjustFactorUpload',
        params: {
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      });
    }
  }
});

/***/ }),

/***/ 1295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_KanbanAdjust__ = __webpack_require__(1160);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['closeKbaUploadModal'],
  data: function data() {
    return {
      isLoadModal: false,
      isError: true,
      kbaType: 0,
      kbaData: []
    };
  },
  mounted: function mounted() {},

  methods: {
    checkAdjust: function checkAdjust() {
      var _this = this;

      this.kbaData = [];
      var formData = new FormData();
      var kbaFile = document.querySelector('#kba_file');
      formData.append('kba_type', this.kbaType);
      formData.append('kba_file', kbaFile.files[0]);
      this.isLoadModal = true;
      __WEBPACK_IMPORTED_MODULE_3__models_KanbanAdjust__["a" /* default */].checkAdjust(this.$store.state.URLHost, formData, this.header, function (result) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result.data).length > 0) {
          _this.kbaData = result.data;
        } else {
          _this.kbaData = [];
        }
        _this.isError = result.is_error;
        _this.isLoadModal = false;
        _this.alert_msg('success', 'Successful.', result.message);
      }, function (error) {
        _this.isLoadModal = false;
        _this.alert_msg('success', 'Something went wrong.', error.message);
      });
    },
    createAdjust: function createAdjust() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
        title: 'Kanban Adjust Upload',
        text: 'You want to Create Kanban Adjust?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, Create now!',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          var kba_data = [];
          if (_this2.kbaType === '1') {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.kbaData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                kba_data.push({
                  ps_id: item.ps_id,
                  kba_current: item.kba_current,
                  kba_new: item.kba_new,
                  kba_change: item.kba_change,
                  kba_type: item.kba_type,
                  kba_t1: item.kba_t1_use,
                  start_date: item.start_date,
                  end_date: item.end_date,
                  cdcl_list: item.cycle_list
                });
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          } else if (_this2.kbaType === '2') {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.kbaData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _item = _step2.value;

                kba_data.push({
                  ps_id: _item.ps_id,
                  kba_current: _item.kba_current,
                  kba_new: _item.kba_new,
                  kba_change: _item.kba_change,
                  kba_t1: _item.kba_t1_use,
                  kba_t2: _item.kba_t2_use,
                  start_date: _item.start_date,
                  mid_date: _item.mid_date,
                  end_date: _item.end_date,
                  cdcl_list: _item.cycle_list
                });
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            // error type
          }
          var formData = {
            kba_type: _this2.kbaType,
            kba_data: kba_data
          };
          __WEBPACK_IMPORTED_MODULE_3__models_KanbanAdjust__["a" /* default */].createAdjust(_this2.$store.state.URLHost, formData, _this2.header, function (response) {
            kba_data = [];
            _this2.kbaType = 0;
            _this2.$refs.kba_file.value = null;
            _this2.kbaData = [];
            _this2.isError = 1;
            _this2.alert_msg('success', 'Successful.', response.message);
          }, function (error) {
            kba_data = [];
            _this2.kbaType = 0;
            _this2.$refs.kba_file.value = null;
            _this2.kbaData = [];
            _this2.isError = 1;
            _this2.alert_msg('success', 'Something went wrong.', error.message);
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KanbanAdjustUpload_vue__ = __webpack_require__(1295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb00124_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KanbanAdjustUpload_vue__ = __webpack_require__(1481);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KanbanAdjustUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb00124_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KanbanAdjustUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Kanban Adjust Upload")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button"},on:{"click":_vm.closeKbaUploadModal}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 p-r-0 mb-2 d-grid gap-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.kbaType),expression:"kbaType"}],staticClass:"form-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.kbaType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- Select Adjust Type --")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Adjust Factor")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Adjust Dayoff")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 p-r-0 mb-2 d-grid gap-2"},[_c('input',{ref:"kba_file",staticClass:"form-control",attrs:{"type":"file","name":"kba_file","id":"kba_file"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 col-xs-12 p-r-0 mb-2"},[_c('button',{staticClass:"btn btn-info btn-sm btn-sm-fix",staticStyle:{"margin-right":"9px"},attrs:{"type":"button"},on:{"click":_vm.checkAdjust}},[_c('svg',{staticClass:"bi bi-eyeglasses",staticStyle:{"margin-right":"3px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 7 8a1 1 0 0 1 2 0 3 3 0 0 0 5.959.5h.541a.5.5 0 0 0 0-1h-.541a3 3 0 0 0-5.584-.953A1.993 1.993 0 0 0 8 6c-.532 0-1.016.208-1.375.547zM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"}})]),_vm._v("\n          Check\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm btn-sm-fix",attrs:{"type":"button","disabled":_vm.isError == 1},on:{"click":_vm.createAdjust}},[_c('svg',{staticClass:"bi bi-folder-check",staticStyle:{"margin-right":"3px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M15.854 10.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .707-.708l1.146 1.147 2.646-2.647a.5.5 0 0 1 .708 0z"}})]),_vm._v("\n          Create\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('label',[_vm._v("Kanban Adjust List")]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm customize-table mb-0 v-middle"},[_c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Dock")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part ID")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part No.")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part Name")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Qty/Box")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Unit")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Supplier Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Supplier Name")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Supplier Plant Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Current")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("New")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Change")]),_vm._v(" "),(_vm.kbaType == 1)?_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Type")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.isLoadModal == true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"20"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),(_vm.kbaData.length == 0 && _vm.isLoadModal == false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"20"}},[_vm._v("No Data")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.kbaData),function(row,i){return _c('tr',{key:'pl' + i},[_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.dk_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.pr_id))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.pr_number))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.pr_name))]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_vm._v(_vm._s(row.qty))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.unit))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.spl_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.spl_name))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(row.spl_pl_code))]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_vm._v(_vm._s(row.kba_current))]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_vm._v(_vm._s(row.kba_new))]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_vm._v(_vm._s(row.kba_change))]),_vm._v(" "),(_vm.kbaType == 1)?_c('td',{staticClass:"align-top border-top"},[_vm._v(_vm._s(row.kba_type))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.is_error === 0),expression:"row.is_error === 0"}],staticClass:"badge bg-success"},[_vm._v("Valid")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.is_error === 1),expression:"row.is_error === 1"}],staticClass:"badge bg-danger"},[_vm._v("Invalid")])])])})],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-lg-flex row"},[_c('div',{staticClass:"col-sm-10"},[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(_vm._s(_vm.$route.meta.title_sub !== '' ? _vm.$route.meta.title_sub : _vm.$route.meta.title))]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xs-12 mb-2 d-grid gap-2"})]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-lg-2 col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dock),expression:"dock"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"id":"select2-dock"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dock=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Dock")]),_vm._v(" "),_vm._l((_vm.dock_list),function(d,i){return _c('option',{key:'md' + i,domProps:{"value":d.dk_id}},[_vm._v(" "+_vm._s(d.dk_code)+": "+_vm._s(d.dk_name)+" ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier),expression:"supplier"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"id":"select2-supplier"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.supplier=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Supplier")]),_vm._v(" "),_vm._l((_vm.supplier_list),function(spl,index){return _c('option',{key:'spl' + index,domProps:{"value":spl.spl_id}},[_vm._v(_vm._s(spl.spl_code + ': ' + spl.spl_name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.part),expression:"part"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"id":"select2-part"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.part=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Part")]),_vm._v(" "),_vm._l((_vm.part_list),function(pr,index){return _c('option',{key:'pr' + index,domProps:{"value":pr.pr_id}},[_vm._v(_vm._s(pr.pr_id_number + ': ' + pr.pr_number))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_auto),expression:"is_auto"}],staticClass:"form-select",attrs:{"name":"is_auto"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.is_auto=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"99"}},[_vm._v("All Status")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Auto")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Manual")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-1 col-md-12 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix",staticStyle:{"margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.active_page = 1
            _vm.search()}}},[_c('i',{staticClass:"fa fa-search mr-1"}),_vm._v(" Search\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-12 col-sm-12 col-xs-12 p-r-0 mb-2 text-right"},[_c('div',{staticClass:"d-inline-block mb-2"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-sm-fix mr-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.goKanbanAdjustFactorUpload()}}},[_c('i',{staticClass:"fa fa-upload mr-1"}),_vm._v(" Adjust Factor Upload")])]),_vm._v(" "),_c('div',{staticClass:"d-inline-block mb-2"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){return _vm.goKanbanAdjustDayoffUpload()}}},[_c('i',{staticClass:"fa fa-upload mr-1"}),_vm._v(" Adjust Dayoff Upload")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.is_load == true)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.result_data.pagination.length == 0 && _vm.is_load == false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"20"}},[_vm._v("No Data")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.result_data.pagination),function(p,i){return _c('tr',{key:'pl' + i},[_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(_vm.per_page * _vm.active_page - (_vm.per_page - i) + 1))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.dk_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.pr_id_number))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.pr_number))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.pr_name))]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_vm._v(_vm._s(p.ps_qty_pack))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.ut_name))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.spl_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.spl_name))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(p.spl_plant_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(p.ps_is_auto === 1),expression:"p.ps_is_auto === 1"}],staticClass:"badge bg-info"},[_vm._v("Auto")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(p.ps_is_auto === 0),expression:"p.ps_is_auto === 0"}],staticClass:"badge bg-warning text-dark"},[_vm._v("Manual")])]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){return _vm.adjustManage({ ps_id: p.ps_id })}}},[_c('i',{staticClass:"fas fa-adjust"}),_vm._v(" Adjust")])])])})],2)])]),_vm._v(" "),(parseInt(_vm.result_data.count) > parseInt(_vm.per_page) && _vm.is_load == false)?_c('div',{staticClass:"text-end mt-3"},[_c('a-pagination',{staticStyle:{"cursor":"pointer"},attrs:{"pageSize":_vm.per_page,"total":_vm.result_data.count,"itemRender":_vm.itemRender},on:{"update:pageSize":function($event){_vm.per_page=$event},"update:page-size":function($event){_vm.per_page=$event},"change":_vm.activePage},model:{value:(_vm.active_page),callback:function ($$v) {_vm.active_page=$$v},expression:"active_page"}})],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Dock")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part ID")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part No.")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part Name")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Qty/Box")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Unit")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Supplier Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Supplier Name")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Supplier Plant Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Actions")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"20"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.efbf2d9dd44e9931d642.js